import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getTrackingQAnsweredFinalValues,
  updateTrackingQAnsweredFinalValues,
} from "../store/qf";
import { COLORS } from "../theme";
import ScoreBar from "./ScoreBar";
import { getLanguagePreference, getBrokerInformation } from "../store/broker";

const QuestionProgress = () => {
  const dispatch = useDispatch();
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference;

  const trackingQAnsweredFinalValues = useSelector(
    getTrackingQAnsweredFinalValues
  );
  const translations = {
    en: {
      allQuestions: "Progress - All Questions",
      essentialQuestions: "Progress - Essential Questions",
    },
    fr: {
      allQuestions: "Progrès - Toutes les Questions",
      essentialQuestions: "Progrès - Questions Essentielles",
    },
  };

  const getTotalScore = ({ numerator, denominator }) => {
    if (denominator === 0 || numerator === 0) return 0;

    return (numerator * 100) / denominator;
  };

  useEffect(() => {
    dispatch(updateTrackingQAnsweredFinalValues());
  }, []);
  const widthDivision = {
    first: "27%",
    second: "67%",
    third: "",
  };
  widthDivision.third = `calc(100% - ${widthDivision.first} - ${widthDivision.second})`;
  const cma = {
    width: "100%",
    height: "60%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    paddingTop: "1vh",
    paddingBottom: "1vh",
  };
  const cmB = {
    display: "flex",
    alignItems: "center",
  };

  const getScoreForAll = () => {
    return Math.round(
      getTotalScore({
        denominator: trackingQAnsweredFinalValues.totalAnswerableQuestions,
        numerator: trackingQAnsweredFinalValues.totalQAnswered,
      })
    );
  };

  const getScoreForImp = () => {
    return Math.round(
      getTotalScore({
        denominator: trackingQAnsweredFinalValues.totalImp,
        numerator: trackingQAnsweredFinalValues.totalImpAnswered,
      })
    );
  };
  const cmc = {
    fontSize: "1.5vmin",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "1.5vmin",
    paddingLeft: "1vmin",
    fontFamily: "GibsonLight",
    letterSpacing: "0.05vmin",
  };
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
      }}
    >
      <div style={{ ...cmB, width: widthDivision.first }}>
        <LabelForBars
          cma={cma}
          cmc={cmc}
          fText={translations[languagepreference].allQuestions}
          lText={translations[languagepreference].essentialQuestions}
        ></LabelForBars>
      </div>
      <div
        style={{
          ...cmB,
          width: widthDivision.second,
        }}
      >
        <QuestionProgressBars
          commonStyle={cma}
          scoreForAll={getScoreForAll()}
          scoreForImp={getScoreForImp()}
        ></QuestionProgressBars>
      </div>
      <div style={{ ...cmB, width: widthDivision.third }}>
        <LabelForBars
          cma={cma}
          cmc={cmc}
          fText={`${getScoreForAll()} %`}
          lText={`${getScoreForImp()} %`}
        ></LabelForBars>
      </div>
    </div>
  );
};

const LabelForBars = ({ cma, cmc, fText, lText }) => {
  return (
    <div style={cma}>
      <div style={cmc}>{fText}</div>
      <div style={cmc}>{lText}</div>
    </div>
  );
};
const QuestionProgressBars = ({ commonStyle, scoreForAll, scoreForImp }) => {
  return (
    <div
      style={{ ...commonStyle, paddingTop: "1.3vh", paddingBottom: "1.3vh" }}
    >
      <SingleScoreBar
        score={scoreForAll}
        color={COLORS.secondary_skyblue}
      ></SingleScoreBar>
      <SingleScoreBar
        score={scoreForImp}
        color={COLORS.secondary_orange}
      ></SingleScoreBar>
    </div>
  );
};

const SingleScoreBar = ({ score, color }) => {
  return (
    <ScoreBar
      height={"0.8vh"}
      fontSize={"1.3vh"}
      color={color}
      bgcolor={COLORS.help_tip}
      score={score}
      noText={true}
    ></ScoreBar>
  );
};

export default QuestionProgress;
